<template>
  <v-toolbar :fixed="fixed" class="primary white--text">
    <!-- <v-toolbar-side-icon @click.native.stop="drawer = !drawer" ></v-toolbar-side-icon> -->
      <v-avatar @click.stop="drawer = !drawer" style="cursor: pointer; border: 2px solid white; border-radius: 100%">
        <img src="/static/logo.png">
      </v-avatar>
    <v-spacer></v-spacer>
    <v-toolbar-title>Verde Dec18</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-chip v-if="user" close @input="logout" class="transparent white--text">
      <v-avatar>
        <img :src="user.avatar">
      </v-avatar>
      <v-icon :class="{'yellow--text': user.roles && user.roles.indexOf('tud-admin') !== -1}">{{user.admin ? 'star' : 'star_border'}}</v-icon>
      <span class="name-span">&nbsp;{{user.username}}</span>
    </v-chip>
    <v-spacer></v-spacer>
  </v-toolbar>
</template>

<script>
  export default {
    computed: {
      notifications () {
        return this.$store.getters.getNotifications
      },
      notificationsCount () {
        return this.notifications.length < 50 ? this.notifications.length : '50+'
      },
      user () {
        return this.$store.getters.getUser
      },
      fixed () {
        return this.$store.getters.appFixed
      },
      drawer: {
        get () {
          return this.$store.getters.appDrawer
        },
        set (val) {
          val ? this.$store.commit('openDrawer') : this.$store.commit('closeDrawer')
        }
      }
    },
    methods: {
      logout () {
        this.$store.dispatch('logout')
          .then(() => {
            this.$router.replace({name: 'Login'})
          })
      }
    }
  }
</script>

<style>
  .name-span {
    display: inline-block;
    max-width: 10vw;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .toolbar__content, .toolbar__extension {
    height: 64px !important;
  }
</style>



// WEBPACK FOOTER //
// Toolbar.vue?612dbe5a